import { PureComponent } from 'react';
import { View, ScrollView, TouchableOpacity, Image } from 'react-native';
import { Label, DocumentTitle, LabelledView, PickerInput, Link, Text, Loading } from '@symbolic/rn-lib';
import { api } from '@symbolic/lib';
import { connect } from '@symbolic/redux';
import { resourceActions } from '~/redux';
import { accentColorForOrg } from '~/helpers/org-helper';
import _ from '@symbolic/lodash';

import K from '~/k';
import AdminMenu from '~/components/admin-menu';
import SecondaryHeader from '~/components/secondary-header';

import createIconWhite from '~/assets/create-icon-white.png';

class ProductPricingRuleRow extends PureComponent {

  render() {
    var {productPricingRule, index} = this.props;

    var textCellStyle = {paddingHorizontal: K.spacing};

    return (
      <View
        dataSet={{'hover-background-double-gray': 1}}
        style={{flexDirection: 'row', alignItems: 'center', height: 30, borderRadius: K.borderRadius, backgroundColor: K.colors.gray, marginBottom: K.margin, marginHorizontal: K.spacing}}
      >
        <Link to={`/admin/product-pricing-rules/${productPricingRule.id}`} style={{paddingLeft: K.spacing, flexDirection: 'row', flex: 1, height: '100%', alignItems: 'center'}}>
          <Text style={{width: 75, opacity: 0.5, ...textCellStyle}}>{productPricingRule.id}</Text>
          <Text style={{flex: 1, ...textCellStyle}}>{productPricingRule.title || productPricingRule.name || 'Untitled Rule'}</Text>
        </Link>
      </View>
    );
  }
}

class AdminProductPricingRulesPage extends PureComponent {
  state = {
    filterMode: 'active',
    isLoading: true
  };

  async componentDidMount() {
    var productPricingRules = await api.get('productPricingRules', {where: {orgId: this.props.session.activeOrg.id}});

    await this.props.trackProductPricingRules({productPricingRules});

    setTimeout(() => this.setState({isLoading: false}));
  }

  handleFilterModeChange = ({value}) => this.setState({filterMode: value});

  createProductPricingRule = async () => {
    var pricingRule = await api.create('productPricingRule', {
      orgId: this.props.session.activeOrg.id,
      title: 'Untitled Pricing Rule',
    });

    this.props.trackProductPricingRules({productPricingRules: [pricingRule]});
  };

  render() {
    var {productPricingRules} = this.props;
    var {filterMode} = this.state;

    var filteredProductPricingRules = _.filter(productPricingRules, productPricingRule => {
      if (filterMode === 'active') return !productPricingRule.deleted;
      if (filterMode === 'archived') return !!productPricingRule.deleted;
      if (filterMode === 'all') return true;
    });

    return (
      <DocumentTitle title={'Admin: Product Pricing Rules'}>
        <View style={{flex: 1, flexDirection: 'row'}}>
          <AdminMenu activeOrg={this.props.session.activeOrg} />
          <View style={{flex: 1}}>
            <SecondaryHeader
              title={'Product Pricing Rules'}
              titleIsEditable
              rightComponent={(
                <View style={{right: 20}}>
                  <LabelledView label='Status' styles={{paddingTop: K.spacing}}>
                    <PickerInput
                      style={{height: K.inputHeight}}
                      buttonStyle={{backgroundColor: K.colors.doubleGray}}
                      showDownArrow={true}
                      options={[
                        {value: 'active', title: 'Active'},
                        {value: 'archived', title: 'Archived'},
                        {value: 'all', title: 'All'},
                      ]}
                      value={this.state.filterMode}
                      onChange={this.handleFilterModeChange}
                    />
                  </LabelledView>
                </View>
              )}
            />
            {this.state.isLoading ? (
              <Loading />
            ) : (
              <>
                <ScrollView style={{flex: 1}} contentContainerStyle={{addingTop: K.spacing, paddingBottom: K.spacing * 4}}>
                  <View style={{paddingLeft: K.spacing * 2, flexDirection: 'row', marginRight: K.spacing}}>
                    {_.map([
                      // {title: 'Rank', style: {width: 75}},
                      {title: 'ID', style: {width: 75}},
                      {title: 'Title', style: {flex: 1}}
                    ], ({title, style}, h) => (
                      <View key={h}
                        style={{...style, padding: K.spacing}}
                      >
                        <Label>{title}</Label>
                      </View>
                    ))}
                  </View>
                  <View>
                    {_.map(_.sortBy(filteredProductPricingRules, ['rank', 'id']), (productPricingRule, index) => (
                      <ProductPricingRuleRow
                        key={productPricingRule.id}
                        {...{productPricingRule, productPricingRules: filteredProductPricingRules, index, ..._.pick(this.props, ['updateProductPricingRules'])}}
                      />
                    ))}
                  </View>
                </ScrollView>
                <TouchableOpacity
                  onPress={() => this.createProductPricingRule()}
                  style={{position: 'fixed', bottom: K.spacing * 2, left: K.spacing * 2, backgroundColor: accentColorForOrg({org: this.props.session.activeOrg}), width: 70, height: 70, borderRadius: 70, alignItems: 'center', 'justifyContent': 'center'}}
                >
                  <Image source={createIconWhite} style={{width: K.calc(35), height: K.calc(35)}}/>
                </TouchableOpacity>
              </>
            )}
          </View>
        </View>
      </DocumentTitle>
    );
  }
}

export default connect({
  mapState: (state) => ({
    productPricingRules: _.get(state, 'resources.productPricingRules.byId')
  }),
  mapDispatch: {
    ..._.pick(resourceActions.productPricingRules, ['updateProductPricingRules', 'trackProductPricingRules']),
  }
})(AdminProductPricingRulesPage);
